const panelStyle = {
  marginBottom: 5,
  background: "white",
  borderRadius: "8px 8px 0 0",
  border: "1px solid #E5E7EB",
};

const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

export const getFaqItems = () => [
  {
    key: "1",
    label: "What is Teamstar?",
    children: (
      <p>
        Teamstar is a leading furniture hardware supplier dedicated to bringing
        innovation, design, and functionality together. We help manufacturers,
      </p>
    ),
    category: "General Questions",
    style: panelStyle,
  },
  {
    key: "2",
    label: "Where is Teamstar based?",
    children: (
      <p>
        We’re proudly based in Malaysia, serving clients locally and across the
        region with fast, reliable service and global-standard products.
      </p>
    ),
    category: "General Questions",
    style: panelStyle,
  },
  {
    key: "3",
    label: "Who do you supply to?",
    children: (
      <p>
        Teamstar works with furniture manufacturers, hardware retailers,
        designers, and renovation professionals. Basically, if you build,
        design, or dream about furniture — we’ve got something for you.
      </p>
    ),
    category: "General Questions",
    style: panelStyle,
  },
  {
    key: "4",
    label: "What kind of products does Teamstar offer?",
    children: (
      <p>
        From hinges and slides to handles, knobs, and lift systems — we cover
        the full range of modern furniture hardware essentials.
      </p>
    ),
    category: "Products",
    style: panelStyle,
  },
  {
    key: "5",
    label: "Can I get samples before placing an order?",
    children: (
      <p>
        Yes, we offer samples for select items so you can test the fit and
        finish before committing. Just contact our sales team to request one.
      </p>
    ),
    category: "Products",
    style: panelStyle,
  },
  {
    key: "6",
    label: "How can I place an order?",
    children: (
      <p>
        You can reach out directly through our website’s contact form, email, or
        phone. Our sales team will guide you through product selection, pricing,
        and shipping options.
      </p>
    ),
    category: "Orders",
    style: panelStyle,
  },
  {
    key: "7",
    label: "How do I get support or ask a product question?",
    children: (
      <p>
        Simply contact us with your order details or product inquiry. Our
        support team will assist you quickly and professionally.
      </p>
    ),
    category: "Support & Technical Help",
    style: panelStyle,
  },
  {
    key: "8",
    label: "Do you offer technical or installation support?",
    children: (
      <p>
        We provide installation guides and can advise on product compatibility.
        For large projects, we can also arrange on-site consultations.
      </p>
    ),
    category: "Support & Technical Help",
    style: panelStyle,
  },
  {
    key: "9",
    label: "What is Teamstar’s mission?",
    children: (
      <p>
        Our mission is to empower furniture makers and designers with reliable,
        innovative, and stylish hardware solutions — helping them build spaces
        that combine beauty, function, and longevity.
      </p>
    ),
    category: "Mission & Vision",
    style: panelStyle,
  },
  {
    key: "10",
    label: "What’s Teamstar’s vision?",
    children: (
      <p>
        To become the most trusted name in furniture hardware across Asia, known
        for quality, creativity, and service that moves the industry forward.
      </p>
    ),
    category: "Mission & Vision",
    style: panelStyle,
  },
];
